/**
 * Nutzerfreundliche Fehlermeldung für KI-„Verbessern“, v. a. wenn der Hub nicht erreichbar ist.
 */
export function improveAiErrorUserMessage(error: unknown, fallback: string): string {
  const e = error as {
    response?: {
      status?: number
      data?: { code?: string; message?: string; error?: string }
    }
  }
  const d = e?.response?.data
  if (d?.code === 'hub_unavailable' && typeof d.message === 'string' && d.message.trim()) {
    return d.message.trim()
  }
  if (e?.response?.status === 503 && typeof d?.message === 'string' && d.message.trim()) {
    return d.message.trim()
  }
  if (typeof d?.message === 'string' && d.message.trim()) return d.message.trim()
  if (typeof d?.error === 'string' && d.error.trim()) return d.error.trim()
  return fallback
}
